import {createContext, useCallback, useContext, useMemo, useState} from "react";

type MobileMenuCtx = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const Ctx = createContext<MobileMenuCtx>({
  isOpen: false,
  open: () => {},
  close: () => {},
  toggle: () => {}
});

export function MobileMenuProvider({children}: {children: React.ReactNode}) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((v) => !v), []);
  const value = useMemo(() => ({isOpen, open, close, toggle}), [isOpen, open, close, toggle]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useMobileMenu() {
  return useContext(Ctx);
}
